<template>
    <div class="modal-content" ref="container">
        <form>
            <div class="modal-header clearfix">
                <h3 class="modal-title pull-left">Delete {{ code }}</h3>
                <button type="button" aria-label="Close" class="close icon icon-close" @click="close()" />
            </div>
            <div class="modal-body">
                <div class="clearfix">
                    <div describedby-text class="alert alert-danger">This will *REMOVE* all existing tenant settings, address book data, homepage data, pages definitions, etc.</div>
                    <div class="form-group">
                        <label class="form-label" for="confirmCode">To confirm, enter the tenant code</label>
                        <input class="form-control" type="text" name="confirmCode" id="confirmCode" v-model="confirmCode" />
                    </div>
                    <AsyncOperationErrors style="margin-top: 5px" :promise="deletePromise" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="deleteFunc">
                    Delete
                    <AsyncOperationStatus :promise="deletePromise" />
                </button>
                <button type="button" class="btn btn-bare" @click="close()">Cancel</button>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
import { defineComponent, inject, ref, SetupContext } from "vue";
import { throwIfNonSuccessStatus, fetchXsrf } from "@/lib/fetchHelpers.3";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
import AsyncOperationErrors from "@/lib/AsyncOperationErrors.3.vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import { useMainStore } from "@/mainStore";
import { changePageInjectKey } from "@/AppShell.3.vue.InjectKeys";
type Props = { code: string; deleteCallback: (uploadData: FormData) => void } & DialogProps;
export default defineComponent({
    props: ["code", "deleteCallback", "triggerElement"],
    components: {
        AsyncOperationStatus,
        AsyncOperationErrors,
    },
    setup(props: Props, { emit }: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        dialogSetup(containerRef, props);
        const mainStore = useMainStore();

        const deletePromise = ref<Promise<boolean>>(null!);
        // const urlSlug = ref(null);
        const confirmCode = ref<string>(null!);
        // const displayLabel = ref(null);
        // const description = ref(null);

        const close = () => {
            emit("close");
        };
        const deleteFunc = async () => {
            deletePromise.value = (async () => {
                if (confirmCode.value != props.code) {
                    throw ["Code does not match confirm code"];
                }

                const uploadData = new FormData();
                uploadData.append("code", props.code);
                const uploadUrl = await mainStore.getUrl("adminTenantManagementDeleteSave");
                let responseJson;
                try {
                    const response = await fetchXsrf(mainStore, uploadUrl, {
                        method: "POST",
                        body: uploadData,
                    });
                    throwIfNonSuccessStatus(response);
                    responseJson = await response.json();
                } catch {
                    debugger;
                    throw ["Unknown error occurred"];
                }
                if (responseJson.Success) {
                    await props.deleteCallback(uploadData);
                    close();
                    return true;
                } else {
                    throw responseJson.Errors;
                }
            })();
        };

        return {
            container: containerRef,
            deletePromise,
            confirmCode,

            close,
            deleteFunc,

            changePage: inject(changePageInjectKey)!,
        };
    },
});
</script>
